import React from 'react'
import Tooltip from '../tooltip/Tooltip.jsx'
class ViewerMode extends React.Component {
	isCurrent = (id, toggled) => {
		return toggled === id
	}

	renderSingleModeIcon = toggled => {
		if (this.isCurrent('none', toggled)) {
			return (
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21"><path fill="#0050BC" fillRule="evenodd" stroke="#003087" strokeWidth="1.25" d="M.625.625h28.75v19.75H.625z"/></svg>			)
		} else {
			return (
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="0 0 34 24"><path fill="#DFDEDA" fillRule="evenodd" stroke="#979692" strokeWidth="1.25" d="M.625.625h32.75v22.75H.625z"/></svg>			)
		}
	}
	renderDoubleModeIcon = toggled => {
		if (this.isCurrent('one', toggled)) {
			return (
<svg xmlns="http://www.w3.org/2000/svg" width="30" height="21" viewBox="0 0 30 21"><g fill="none" fillRule="evenodd" stroke="#003087" strokeWidth="1.25"><path d="M29.375 20.375H.625V.625h28.75z"/><path fill="#0050BC" d="M20.557 20.375H.631V.625h19.926z"/></g></svg>			)
		} else {
			return (
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="24" viewBox="0 0 34 24"><g fill="none" fillRule="evenodd" stroke="#979692" strokeWidth="1.25"><path d="M33.375 23.375H.625V.625h32.75z"/><path fill="#DFDEDA" d="M23.381 23.375H.631V.625h22.75z"/></g></svg>			)
		}
	}
	renderTripleModeIcon = toggled => {
		if (this.isCurrent('both', toggled)) {
			return (
				<svg xmlns="http://www.w3.org/2000/svg" width="36" height="24" viewBox="0 0 36 24"><g fill="none" fillRule="evenodd" stroke="#003087" strokeWidth="1.25"><path d="M25.375 23.375H.625V.625h24.75z"/><path d="M35.375 23.375H.625V.625h34.75z"/><path fill="#0050BC" d="M15.375 23.375H.625V.625h14.75z"/></g></svg>
				// <svg width="32" height="21" viewBox="0 0 32 21" xmlns="http://www.w3.org/2000/svg"><g transform="rotate(180 16 10.5)" stroke="#184F8D" fill="none"><rect x="9.514" y=".625" width="21.861" height="19.75" rx="2"/><rect x=".625" y=".625" width="30.75" height="19.75" rx="2"/><rect fill="#0050bc" x="18.403" y=".625" width="12.972" height="19.75" rx="2"/></g></svg>
			)
		} else {
			return (
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="21" viewBox="0 0 32 21"><g fill="none" fillRule="evenodd" stroke="#979692" strokeWidth="1.25"><path d="M22.486 20.375H.625V.625h21.861z"/><path d="M31.375 20.375H.625V.625h30.75z"/><path fill="#DFDEDA" d="M13.597 20.375H.625V.625h12.972z"/></g></svg>			)
		}
	}
	render() {
		const toggled = this.props.toggledSetting

		return (
			<div className="viewer-mode">
				<span className="viewer-mode__heading">Viewer Mode</span>
				<Tooltip tooltipText="Single View">
					<button
						className="viewer-mode__btn"
						onClick={() => this.props.updateToggledSetting('none')}
						type="button"
					>
						{this.renderSingleModeIcon(toggled)}
						<span className="visually-hidden">Hide both menus</span>
					</button>
				</Tooltip>
				<Tooltip tooltipText="Reader Pane">
					<button
						className="viewer-mode__btn"
						onClick={() => this.props.updateToggledSetting('one')}
						type="button"
					>
						{this.renderDoubleModeIcon(toggled)}
						<span className="visually-hidden">Display Left Menu Only</span>
					</button>
				</Tooltip>
				<Tooltip tooltipText="Triple View">
					<button
						className="viewer-mode__btn"
						onClick={() => this.props.updateToggledSetting('both')}
						type="button"
					>
						{this.renderTripleModeIcon(toggled)}
						<span className="visually-hidden">Display both menus</span>
					</button>
				</Tooltip>
			</div>
		)
	}
}
export default ViewerMode
